import $ from 'jquery';

const ScaServiceFactory = function ScaServiceFactory( $q, $rootScope, $http, endPoints, NewBackendService, PollingService, StorageService){
  
  'ngInject';

  const POLLER_INTERVAL_MILLISECONDS = 1500;
  const pollerName = "POLLER_SCA_TYPE_";

const sendScaNotification = (type) => $q((resolve, reject) => {
  let url = `/api/sec/v2/oauth/sca/check`;
  if (type) url = url + '?type=' + type;
  NewBackendService.invokeWebApiPost(url, {}, false).then(response => resolve(response.data), reject);
});

const getScaPollerStatus = (transactionId) => $q((resolve, reject) =>  NewBackendService.invokeWebApiGet('/api/sec/v2/oauth/sca/polling', {transactionId}, true).then(response => resolve(response.data), reject)) 

const startPoller = (type) => {
  sendScaNotification(type).then(response => {
      $rootScope.$broadcast("POLLER_SCA_INITIALIZED_TYPE_" + type);
      PollingService.startPolling(pollerName + type, getScaPollerStatus, response.commandTransactionId, POLLER_INTERVAL_MILLISECONDS, result =>{
          const resultPolling = result.status;
          $rootScope.$broadcast("POLLER_SCA_STATUS_TYPE_" + type, resultPolling);
          console.log("Inside polling")
          if (resultPolling === "COMPLETED") {
              renewTokenWeb(response.commandTransactionId).then(response => {
                  $rootScope.$broadcast("POLLER_SCA_COMPLETED_TYPE_" + type, response);
              }, (error) => {
                  $rootScope.$broadcast("POLLER_SCA_ERROR_TYPE_" + type, error);
              });
              stopPoller(type);
          } else if (resultPolling !== "REQUESTED" && resultPolling !== "CHECKED") {
              $rootScope.$broadcast("POLLER_SCA_STOPPED_TYPE_" + type, resultPolling);
              stopPoller(type);
          }
      }, error => {
          $rootScope.$broadcast("POLLER_SCA_ERROR_TYPE_" + type, error);
          stopPoller(type);
      });
  })
};

const stopPoller = type => {
  PollingService.stopPolling(pollerName + type);
};

const renewTokenWeb = (pScaId) => $q((resolve, reject) => {
  const data = $.param({     
      grant_type: 'refresh_token',
      refresh_token: StorageService.getLocalStorage('refresh_token'), 
      clientId: "webapp",
      scaId: pScaId
  });
  $http.post(`${endPoints.baseUrl}${endPoints.authenticatorUrl}`, 
    data, {
      ignoreAuthModule: true,
      customErrorManagement: true,
      headers: {
        'Authorization': 'Basic d2ViYXBwOndlYmFwcF9zZWNyZXQ=',
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then((response) => {
      StorageService.setLocalStorage('access_token', response.data.access_token);
      StorageService.setLocalStorage('refresh_token', response.data.refresh_token);
      resolve();
    }, () => {
      reject();
    })
})

const service = {
  sendScaNotification,
  getScaPollerStatus,
  startPoller,
  stopPoller
}
  

  return service;
};

export default ScaServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/sca.factory.js
 **/